import React from 'react'
import { Platform, View, ViewStyle } from 'react-native'

import { Button } from '../button'
import { Text } from '../text'
import { SvgIcon } from '../svg-icon'
import { color } from '../../theme'

import { iconGoogle } from '../../assets/icons/generated/icon-Google.icon'
import { iconApple } from '../../assets/icons/generated/icon-Apple.icon'
import { iconLock } from '../../assets/icons'

interface SocialLoginButtonsProps {
  googleLogin: () => void
  /**
   * Hidden for android devices
   */
  appleLogin: () => void
  containerStyle?: ViewStyle
  ssoLogin?: () => void
}
export const SocialLoginButtons = (props: SocialLoginButtonsProps) => {
  const { ssoLogin, googleLogin, appleLogin, containerStyle } = props

  return (
    <View style={{ ...ROOT, ...containerStyle }}>
      <Button
        style={{ backgroundColor: '#fff' }}
        fullWidth
        variant="outlined"
        onPress={googleLogin}
      >
        <SvgIcon size={24} src={iconGoogle} />
        <Text
          variant="labelEmphasized"
          style={{ color: color.shade50, marginLeft: 12 }}
          tx="Onboarding.Login.googleContinue"
        />
      </Button>
      {Platform.OS !== 'android' && (
        <Button
          style={{ backgroundColor: '#fff' }}
          fullWidth
          variant="outlined"
          onPress={appleLogin}
        >
          <SvgIcon size={24} style={{ bottom: 2 }} src={iconApple} />
          <Text
            style={{ color: color.shade50, marginLeft: 12 }}
            variant="labelEmphasized"
            tx="Onboarding.Login.appleContinue"
          />
        </Button>
      )}
      {ssoLogin && (
        <Button fullWidth variant="outlined" onPress={ssoLogin}>
          <SvgIcon size={24} src={iconLock} />
          <Text
            variant="labelEmphasized"
            style={{ color: color.shade50, marginLeft: 12 }}
            text="Continue with SSO"
          />
        </Button>
      )}
    </View>
  )
}

const ROOT: ViewStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  width: '100%',
}
